import { Vue, Component } from 'vue-property-decorator';

@Component
export default class EditorActionMixin extends Vue {
  get editorAction() {
    return this.$route.meta.action;
  }

  get isCreateAction() {
    return this.editorAction === 'create';
  }

  get isEditAction() {
    return this.editorAction === 'edit';
  }
}
